import BaseModel from "./base/baseModel";

export default class ConfiguracaoRotuloUsuarioModel extends BaseModel {
    id?: number = null;
    configuracaoRotuloId?: number = null;
    usuarioId?: number = null;
    usuarioNome: string = null;
    nomeImpressora: string = null;
}

